import CommonIcons from "@base/assets/icons";

interface IProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  placeholder: string;
  hasError?: boolean;
  onClick: () => void;
}

/**
 * Shows only the chosen entry and opens the full list on click. Address books and clinic networks
 * can run long, and listing every entry inline pushed the rest of the booking form off screen.
 */
export default function SelectionTrigger({ title, description, placeholder, hasError, onClick }: IProps) {
  const isEmpty = !title && !description;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full text-left px-3 py-2 rounded-lg border bg-common-white flex items-center gap-3 hover:border-common-primary ${
        hasError ? "border-common-red500" : "border-common-divider"
      }`}
    >
      <CommonIcons.EnvironmentOutlined className="text-common-subtext shrink-0" />

      <div className="grow min-w-0">
        {isEmpty ? <span className="text-common-subtext text-sm font-normal font-['Inter']">{placeholder}</span> : null}

        {title ? <div className="text-common-maintext text-sm font-medium font-['Inter'] line-clamp-2">{title}</div> : null}

        {description ? <div className="text-common-subtext text-xs font-normal font-['Inter'] line-clamp-2">{description}</div> : null}
      </div>

      <CommonIcons.DownOutlined className="text-common-subtext text-xs shrink-0" />
    </button>
  );
}
